import { render, staticRenderFns } from "./SaveAmountCardChip.vue?vue&type=template&id=a645a76e&"
import script from "./SaveAmountCardChip.vue?vue&type=script&lang=js&"
export * from "./SaveAmountCardChip.vue?vue&type=script&lang=js&"
import style0 from "./SaveAmountCardChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports